//store.js
import { configureStore } from "@reduxjs/toolkit";
import aboutUsReducer from "./reducers/aboutUs";
import servicesReducer from "./reducers/services";
import ReviewsReducer from "./reducers/reviews";
import MealsReducer from "./reducers/meals";
import userReducer from "./reducers/user";
import videosReducer from "./reducers/videos";
import videoCategorysReducer from "./reducers/videoCategory";
import CategorysReducer from "./reducers/category";
import BooksReducer from "./reducers/books";
import casesReducer from "./reducers/cases";
import pleadingsReducer from "./reducers/pleading";
import featuredMealsReducer from "./reducers/featuredMeals";
const Store = configureStore({
    reducer: { 
        AboutUs: aboutUsReducer,
        Services: servicesReducer,
        Reviews: ReviewsReducer,
        Meals:MealsReducer,
        Users:userReducer,
        Videos:videosReducer,
        VideoCategory:videoCategorysReducer,
        Categorys:CategorysReducer,
        Books:BooksReducer,
        Cases:casesReducer,
        Pleadings:pleadingsReducer,
        FeaturedMeals:featuredMealsReducer

     },
});

export default Store